import {
  Card,
  CardContent,
  Switch,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import _ from 'lodash';

interface CommonRolesDialogProps {
  cardClass: string;
  cardContentClass: string;
  computeUserEnabled: boolean | undefined;
  setComputeUserEnabled: (computeUserEnabled: boolean) => void;
  dataScientistEnabled: boolean | undefined;
  setDataScientistEnabled: (dataScientistEnabled: boolean) => void;
  databaseUserEnabled: boolean | undefined;
  setDatabaseUserEnabled: (databaseUserEnabled: boolean) => void;
  s3BucketUserEnabled: boolean | undefined;
  setS3BucketUserEnabled: (s3BucketUserEnabled: boolean) => void;
  featureFlagUserEnabled: boolean | undefined;
  setFeatureFlagUserEnabled: (featureFlagUserEnabled: boolean) => void;
}

export const CommonRolesDialog = ({
  cardClass,
  cardContentClass,
  setComputeUserEnabled,
  computeUserEnabled,
  setDataScientistEnabled,
  dataScientistEnabled,
  setDatabaseUserEnabled,
  databaseUserEnabled,
  setS3BucketUserEnabled,
  s3BucketUserEnabled,
  setFeatureFlagUserEnabled,
  featureFlagUserEnabled,
}: CommonRolesDialogProps) => {
  function updateComputeUserEnabled() {
    setComputeUserEnabled(!computeUserEnabled);
  }

  function updateDataScientistEnabled() {
    setDataScientistEnabled(!dataScientistEnabled);
  }

  function updateDatabaseUserEnabled() {
    setDatabaseUserEnabled(!databaseUserEnabled);
  }

  function updates3BucketUserEnabled() {
    setS3BucketUserEnabled(!s3BucketUserEnabled);
  }

  function updateFeatureFlagUserEnabled() {
    setFeatureFlagUserEnabled(!featureFlagUserEnabled);
  }

  return (
    <Card className={cardClass}>
      <CardContent className={cardContentClass}>
        <TableContainer component={Paper}>
          <Table aria-label="common roles table">
            <TableHead>
              <TableRow>
                <TableCell>Role Name</TableCell>
                <TableCell align="left">Enabled</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="left" component="th" scope="row">
                  Compute User
                </TableCell>
                <TableCell align="left">
                  <Switch
                    id="compute_user"
                    name="compute_user"
                    checked={computeUserEnabled}
                    onChange={updateComputeUserEnabled}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" component="th" scope="row">
                  Data Scientist
                </TableCell>
                <TableCell align="left">
                  <Switch
                    id="data_scientist"
                    name="data_scientist"
                    checked={dataScientistEnabled}
                    onChange={updateDataScientistEnabled}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" component="th" scope="row">
                  Database User
                </TableCell>
                <TableCell align="left">
                  <Switch
                    id="database_user"
                    name="database_user"
                    checked={databaseUserEnabled}
                    onChange={updateDatabaseUserEnabled}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" component="th" scope="row">
                  S3 Bucket User
                </TableCell>
                <TableCell align="left">
                  <Switch
                    id="s3_bucket_user"
                    name="s3_bucket_user"
                    checked={s3BucketUserEnabled}
                    onChange={updates3BucketUserEnabled}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" component="th" scope="row">
                  FeatureFlag User
                </TableCell>
                <TableCell align="left">
                  <Switch
                    id="featureflag_user"
                    name="featureflag_user"
                    checked={featureFlagUserEnabled}
                    onChange={updateFeatureFlagUserEnabled}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};
